const initialState = () => ({
  id: null,
  name: null,
  desc: null,
  list_id: null,
  priority_id: null,
  type_id: null,
  assigned_to_user_id: null
})

export default {
  namespaced: true,
  state: initialState(),
  actions: {
    fields({ commit, rootState }, data) {
      // core fields
      commit('assign', data)
      rootState.provider.fields.all.forEach(f =>
        commit('field', {
          field: f.name,
          value: data[f.name]
        })
      )
    }
  },
  mutations: {
    assign(state, data) {
      // Assign core fields
      const { id, name, desc, list_id } = data
      state.id = id
      state.name = name
      state.desc = desc
      state.list_id = list_id
      state.priority_id = null
      state.type_id = null
      state.assigned_to_user_id = null
    },
    field(state, data) {
      state[data.field] = data.value
    },
    reset(state) {
      Object.assign(state, initialState())
    }
  }
}
